import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { MaliyetKalemiEditComponent } from './maliyet-kalemi-edit.component';
import { MaliyetKalemiKartComponent } from './maliyet-kalemi-kart.component';

@DinamikBilesen({
  id: 'maliyet-kalemi',
  baslik: 'Maliyet Kalemi',
  aciklama: 'Maliyet kalemi ekle',
  ikon: 'dollar',
  kategori: 'bakim',
})
class MaliyetKalemi {
  paylas_kutusu = MaliyetKalemiEditComponent;
  paylasilmis_kart = MaliyetKalemiKartComponent;
}
